const cookieHandler = {
// Doc: https://code.area17.com/a17/a17-helpers/wikis/cookieHandler-create
// Doc: https://code.area17.com/a17/a17-helpers/wikis/cookieHandler-delete
// Doc: https://code.area17.com/a17/a17-helpers/wikis/cookieHandler-read

    create(name, value, days) {
        let expires = '';
        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = `; expires=${date.toGMTString()}`;
        }
        document.cookie = `${name}=${value}${expires}; path=/;secure`;
    },
    createMin(name, value, min) {
        let expires = '';
        if (min) {
            const date = new Date();
            date.setTime(date.getTime() + (min * 60 * 1000));
            expires = `; expires=${date.toGMTString()}`;
        }
        document.cookie = `${name}=${value}${expires}; path=/;secure`;
    },
    createSec(name, value, sec) {
        let expires = '';
        if (sec) {
            const date = new Date();
            date.setTime(date.getTime() + (sec * 1000));
            expires = `; expires=${date.toGMTString()}`;
        }
        document.cookie = `${name}=${value}${expires}; path=/;secure`;
    },
    delete(name) {
        if (name) {
            this.create(name, '', -1);
        }
    },
    read(name) {
        if (name) {
            const nameEQ = `${name}=`;
            const ca = document.cookie.split(';');
            for (let i = 0; i < ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) === ' ') {
                    c = c.substring(1, c.length);
                }
                if (c.indexOf(nameEQ) === 0) {
                    return c.substring(nameEQ.length, c.length);
                }
            }
            return null;
        }
        return null;
    },
};

export default cookieHandler;
